export default "__VITE_ASSET__BTe9k1HR__"